import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import ApplicationFormView from "../components/ApplicationFormView/ApplicationFormView";
import LinkExpiredPage from "../components/ApplicationFormView/LinkExpiredPage";
import CenterLoader from "../components/CenterLoader";

const API_BASE = "https://homeowner-staging.azurewebsites.net/api";

const ApplicationForm = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");
  const [loading, setLoading] = useState(true);
  const [isActive, setIsActive] = useState<boolean | null>(null);

  useEffect(() => {
    const fetchApplicationStatus = async () => {
      if (!id) return;

      try {
        setLoading(true);

        const url =
          type === "staging"
            ? "https://homeowner-staging.azurewebsites.net/api"
            : "https://homeowner-backend.azurewebsites.net/api";

        const res = await axios.get(
          `${url}/properties/${id}/application-status`,
          {
            headers: { "Content-Type": "application/json" },
            // withCredentials: true, // ✅ Use this only if cookies are required
          }
        );

        // ✅ Use the response data
        setIsActive(res.data?.applicationFormActive ?? false);
      } catch (err) {
        console.error("Failed to fetch application status:", err);
        setIsActive(false); // fallback to expired
      } finally {
        setLoading(false);
      }
    };

    fetchApplicationStatus();
  }, [id]);

  if (!id || loading) {
    return <CenterLoader />;
  }

  if (!isActive) {
    return <LinkExpiredPage />;
  }

  return <ApplicationFormView />;
};

export default ApplicationForm;
